export const HOTSTAR_URL = "https://www.hotstar.com/in/shows/bigg-boss/14714";

// Single source of truth for contestant imagery.
// Image URLs are intentionally left as-is for a later image refresh.
export const CURRENT_SEASON_NUMBER = 10;
export const CURRENT_PHONE = "+918886650451";

const placeholder = (name) =>
  `https://placehold.co/720x960/101323/F5F7FF?text=${encodeURIComponent(name)}`;

const contestant = (name, profession, bio = "Bigg Boss Tamil housemate.", img = null) => ({
  id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  name,
  profession,
  bio,
  img: img || placeholder(name),
});

export const season10Contestants = [
  contestant("Lakshmi Priya", "Television & film actress", "Known for her work in Tamil television and film, including the serial Mahanadhi.", "https://cdn.strawpoll.com/images/polls/options/e7ZJeBDGg3K-c.png"),
  contestant("Shathiga", "Actor", "Tamil actor known for appearances in films including Naan Mahaan Alla, Nenjil Thunivirunthal and Vezham.", "https://cdn.strawpoll.com/images/polls/options/Q0ZpPN99ZMB-c.png"),
  contestant("Prithivinath", "Actor & creator", "Season 10 housemate introduced during the grand launch.", "https://cdn.strawpoll.com/images/polls/options/3RnYMv8BneA-c.png"),
  contestant("Javeed Sheriff", "Model & digital creator", "Model and digital personality who entered the Season 10 house.", "https://cdn.strawpoll.com/images/polls/options/PKglQj1EZp0-c.png"),
  contestant("Shama", "Common Man contestant", "Entered the Bigg Boss Tamil house through The Common Man selection route.", "https://cdn.strawpoll.com/images/polls/options/PKglQjD1Zp0-c.png"),
  contestant("Muniyammal", "Common Man contestant", "Entered the Bigg Boss Tamil house through The Common Man selection route.", "https://cdn.strawpoll.com/images/polls/options/w4nWxXMdgAL-c.png"),
  contestant("Jason Kaushi", "Common Man contestant", "Entered the Bigg Boss Tamil house through The Common Man selection route.", "https://cdn.strawpoll.com/images/polls/options/Qrgee20XgpY-c.png"),
  contestant("Muthazhagi", "Actor", "Actor and Season 10 housemate introduced during the grand launch.", "https://cdn.strawpoll.com/images/polls/options/xVg7oJ6pgrR-c.png"),
  contestant("Asmitha Neelamegam", "Makeup artist", "Celebrity makeup artist and Season 10 housemate.", "https://cdn.strawpoll.com/images/polls/options/61gDz3R5ywd-c.png"),
  contestant("Avinash Ashok", "Actor", "Tamil actor and Season 10 housemate.", "https://cdn.strawpoll.com/images/polls/options/X3nk5pBjZEP-c.png"),
  contestant("Black Pandi", "Actor & comedian", "Film actor and comedian who entered the Season 10 house.", "https://cdn.strawpoll.com/images/polls/options/ajnEa5LBnWV-c.png"),
  contestant("Vinothbabu M", "Actor & writer", "Actor-writer and Season 10 housemate.", "https://cdn.strawpoll.com/images/polls/options/kogjwlj1Z6M-c.png"),
  contestant("Chandini Tamilarasan", "Film & television actress", "Tamil actress known for work across television and cinema.", "https://cdn.strawpoll.com/images/polls/options/7rnzRqOanOl-c.png"),
  contestant("Savinya Velu", "Performer", "Season 10 housemate introduced during the grand launch.", "https://cdn.strawpoll.com/images/polls/options/eJnvBNkEnv4-c.png"),
  contestant("Kumaran Thangarajan", "Television & film actor", "Actor known for Tamil television and film work, including Pandian Stores.", "https://cdn.strawpoll.com/images/polls/options/ajnEa5DNnWV-c.png"),
  contestant("Raaghav Ranganathan", "Actor & dancer", "Actor and dancer who entered the Season 10 house.", "https://cdn.strawpoll.com/images/polls/options/kjn1kRBdZQe-c.png"),
  contestant("Dhanya Pallath", "Actor & digital creator", "Actor and social-media content creator known for her entertainment work.", "https://cdn.strawpoll.com/images/polls/options/xVg7oJPGgrR-c.png"),
  contestant("Mohammed Ansar", "Television actor & comedian", "Television entertainer and comedian known for Cooku With Comali.", "https://cdn.strawpoll.com/images/polls/options/Qrgee2kRgpY-c.png"),
  contestant("Mukesh MK", "Actor", "Young Tamil actor known for the JioHotstar sports drama series Nadu Center.", "https://cdn.strawpoll.com/images/polls/options/e6Z2j6k5ZNG-c.png"),
  contestant("Manivannan", "Common Man contestant", "Entered the Bigg Boss Tamil house as the season's first wild card.", "https://cdn.strawpoll.com/images/polls/options/e2na2JPzgBO-c.png"),
];

export const seasonArchives = [
  {
    number: 1, year: 2017, title: "Bigg Boss Tamil Season 1", theme: "Original", host: "Kamal Haasan",
    winner: "Arav", runnerUp: "Snehan", days: 98,
    contestants: [
      "Arav", "Snehan", "Harish Kalyan", "Ganesh Venkatraman", "Bindu Madhavi", "Suja Varunee", "Vaiyapuri",
      "Kajal Pasupathi", "Raiza Wilson", "Gayathri Raguram", "Shakthi Vasudevan", "Maria Juliana", "Oviya",
      "Namitha", "Harathi Ganesh", "Ganja Karuppu", "Bharani", "Anuya Bhagvath", "Sri"
    ],
  },
  {
    number: 2, year: 2018, title: "Bigg Boss Tamil Season 2", theme: "Season 2", host: "Kamal Haasan",
    winner: "Riythvika", runnerUp: "Aishwarya Dutta", days: 105,
    contestants: [
      "Riythvika", "Aishwarya Dutta", "Vijayalakshmi Feroz", "Janani Iyer", "Yashika Aannand", "Thaadi Balaji",
      "Mumtaz", "Sendrayan", "Daniel Annie Pope", "Mahat Raghavendra", "Vaishnavi Prasad", "Ponnambalam",
      "Shariq Hassan", "Ramya NSK", "Nithya Balaji", "Ananth Vaidyanathan", "Mamathi Chari"
    ],
  },
  {
    number: 3, year: 2019, title: "Bigg Boss Tamil Season 3", theme: "Chettinad-inspired house", host: "Kamal Haasan",
    winner: "Mugen Rao", runnerUp: "Sandy", days: 105,
    contestants: [
      "Mugen Rao", "Sandy", "Losliya Mariyanesan", "Sherin Shringar", "Tharshan Thiyagarajah", "Kavin Raj",
      "Cheran", "Vanitha Vijayakumar", "Kasthuri Shankar", "Abhirami Venkatachalam", "Jangiri Madhumitha",
      "Sakshi Agarwal", "Saravanan", "Reshma Pasupuleti", "Meera Mitun", "Mohan Vaidya", "Fathima Babu"
    ],
  },
  {
    number: 4, year: 2020, title: "Bigg Boss Tamil Season 4", theme: "Season 4", host: "Kamal Haasan",
    winner: "Aari Arujunan", runnerUp: "Balaji Murugadoss", days: 105,
    contestants: [
      "Aari Arujunan", "Balaji Murugadoss", "Rio Raj", "Ramya Pandian", "Som Shekar", "Gabriella Charlton",
      "Shivani Narayanan", "Aajeedh Khalique", "Anitha Sampath", "Archana Chandhoke", "Nisha Ravikrishnan",
      "Ramesh Venkat", "Sanam Shetty", "Samyuktha Karthik", "Suchitra Ramadurai", "Suresh Chakravarthi",
      "Rekha Harris", "Jithan Ramesh"
    ],
  },
  {
    number: 5, year: 2021, title: "Bigg Boss Tamil Season 5", theme: "Nature", host: "Kamal Haasan",
    winner: "Raju Jeyamohan", runnerUp: "Priyanka Deshpande", days: 105,
    contestants: [
      "Raju Jeyamohan", "Priyanka Deshpande", "Pavni Reddy", "Amir", "Niroop Nandakumar", "Thamarai Selvi",
      "Ciby Bhuvana Chandran", "Sanjeev Venkat", "Varun", "Akshara Reddy", "Abhinay Vaddi", "Imman Annachi",
      "Abishek Raaja", "Iykki Berry", "Isaivani", "Mathumitha Raghunathan", "Suruthi Periyasamy", "Chinnaponnu",
      "Nadia Chang", "Namitha Marimuthu"
    ],
  },
  {
    number: 6, year: 2022, title: "Bigg Boss Tamil Season 6", theme: "Luxurious Mansion", host: "Kamal Haasan",
    winner: "Mohamed Azeem", runnerUp: "Vikraman Radhakrishnan", days: 105,
    contestants: [
      "Mohamed Azeem", "Vikraman Radhakrishnan", "Shivin Ganesan", "Myna Nandhini", "Amudhavanan", "Kathirravan Kabilan",
      "Aaryan Dinesh Kanagaratnam", "Rachitha Mahalakshmi", "Manikandan Rajesh", "Dhanalakshmi", "Janany Kunaseelan",
      "Ayesha Zeenath", "Ram Ramaswamy", "Queency Stanly", "Robert", "Nivaashiyni Krishnan", "Maheshwari Chanakyan",
      "Sheriina", "Asal Kolaar", "Shanthi Arvind", "G. P. Muthu"
    ],
  },
  {
    number: 7, year: 2023, title: "Bigg Boss Tamil Season 7", theme: "Rendula Onnu Paakkalaam", host: "Kamal Haasan",
    winner: "Archana Ravichandran", runnerUp: "Manichandra", days: 105,
    contestants: [
      "Archana Ravichandran", "Manichandra", "Maya S. Krishnan", "Dinesh", "Vishnu", "Vijay Varma", "Vichithra",
      "Poornima Ravi", "Raveena Daha", "Nixen", "Saravana Vickram", "Cool Suresh", "Ananya Rao", "Jovika Vijayakumar",
      "Akshaya Udayakumar", "Bravo", "Bala", "Aishu ADS", "Annabharathi", "Pradeep Antony", "Vinusha Devi",
      "Yugendran", "Bava Chelladurai"
    ],
  },
  {
    number: 8, year: 2024, title: "Bigg Boss Tamil Season 8", theme: "Boys vs Girls", host: "Vijay Sethupathi",
    winner: "Muthukumaran Jegatheesan", runnerUp: "Soundariya Nanjundan", days: 105,
    contestants: [
      "Muthukumaran Jegatheesan", "Soundariya Nanjundan", "VJ Vishal", "Pavithra Janani", "Rayan", "Jacquline Lydia",
      "Deepak Dinkar", "Arun Prasath", "Manjari Narayanan", "Raanav V C", "Anshitha Akbarsha", "Jeffry",
      "Ranjith", "Tharshika", "Sathya SK", "Sachana Namidass", "RJ Ananthi", "Shiva Kumar", "Varshini Venkat",
      "Nagapriya Riya Thiyagarajan", "Sunita Gogoi", "Dharsha Gupta", "Arnav Amjath", "Ravindar Chandrasekaran"
    ],
  },
  {
    number: 9, year: 2025, title: "Bigg Boss Tamil Season 9", theme: "Futuristic", host: "Vijay Sethupathi",
    winner: "Divya Ganesh", runnerUp: "R. Sabarinathan", days: 105,
    contestants: [
      "Divya Ganesh", "R. Sabarinathan", "Vikkals Vikram", "Aurora Sinclair", "Sandra Amy", "Vinoth", "Subiksha Kumar",
      "Kamrudin K", "Parvathy VJ", "Kani Thiru", "Amit Bhargav", "Aadhirai Soundarajan", "FJ Adisayam", "Viyana",
      "Ramya Joo", "Prajean Padmanabhan", "Kemy", "Diwagar", "Praveen Devasagayam", "Tushaar Jayaprakash",
      "Kalaiyarasan", "Apsara CJ", "Pravin Gandhi", "Nandhini R"
    ],
  },
];

export const season9ImageMap = {
  "Demon Pavan": "https://cdn.strawpoll.com/images/polls/options/GJn4QGeqgzm-c.png",
  "Emmanuel": "https://cdn.strawpoll.com/images/polls/options/1Mnwrvq5y7D-c.png",
  "Thanuja Puttaswamy": "https://cdn.strawpoll.com/images/polls/options/wby5ole7gAe-c.png",
  "Kalyan Padala": "https://cdn.strawpoll.com/images/polls/options/NMnQJBGAg6Y-c.png",
  "Divya Nikitha": "https://cdn.strawpoll.com/images/polls/options/DwyoLqwNnAz-c.png",
  "Bharani Shankar": "https://cdn.strawpoll.com/images/polls/options/BDyN4RGkgRO-c.png",
  "Suman Shetty": "https://cdn.strawpoll.com/images/polls/options/YVyPE2BAnNd-c.png",
  "Rithu Chowdary": "https://cdn.strawpoll.com/images/polls/options/poy9KRNwgJr-c.png",
  "Nikhil Nair": "https://cdn.strawpoll.com/images/polls/options/kjn14jWAyQe-c.png",
  "Gaurav Gupta": "https://cdn.strawpoll.com/images/polls/options/eJnvR7oanv4-c.png",
  "Sanjjanaa Galrani": "https://cdn.strawpoll.com/images/polls/options/bVg8P68BgYa-c.png",
};
